/* tslint:disable */
const TRANSLATIONS: any = {
  "i18n.actionBar.cropImage": "Edit",
  "i18n.actionBar.removeImage": "Remove",
  "i18n.actionBar.swapImage": "Swap",
  "i18n.additionalInfoItemLayers.smartSorted.new": "NEW!",
  "i18n.additionalProducts.addToCart": "Add to order",
  "i18n.additionalProducts.frame.description": "High-quality aluminium frame: matt silver, premium real glass, no glue needed",
  "i18n.additionalProducts.frame.emotionalHook": "♥️ Tip:",
  "i18n.additionalProducts.frame.subtitle": "The completed jigsaw puzzle makes a wonderful keepsake – and our <b>frame</b> really shows it off to its best advantage.",
  "i18n.additionalProducts.frame2023.description": "High-quality wood-fibre frame – easy assembly, without glass, incl. puzzle glue",
  "i18n.additionalProducts.framePlastic.description": "High-quality aluminium frame: matt silver, anti-reflective synthetic glass, no glue needed",
  "i18n.additionalProducts.glue.description": "For up to two jigsaw puzzles with 1000 pieces, incl. applicator sponge",
  "i18n.additionalProducts.glue.hook": "Turn your jigsaw puzzle into a work of art.\nIt provides long-lasting adhesion and protection",
  "i18n.additionalProducts.roll.description": "For jigsaw puzzles from 48 to 2000 pieces",
  "i18n.additionalProducts.roll.hook": "No space available? No problem.\nRoll up the jigsaw, put it away and continue later.",
  "i18n.adventCalendarOverlay.activate": "Show the 24-door preview",
  "i18n.adventCalendarOverlay.deactivate": "Turn off the 24-door preview",
  "i18n.adventCalendarOverlay.notice": "(The numbers and lines will not be printed)",
  "i18n.button.addToCart": "Add to cart",
  "i18n.button.apply": "Apply",
  "i18n.button.back": "Back",
  "i18n.button.cancel": "Cancel",
  "i18n.button.cancelAndFix": "Change now",
  "i18n.button.chooseSmartSorted": "Upgrade to SMART SORTED",
  "i18n.button.close": "Close",
  "i18n.button.continue": "Continue",
  "i18n.button.createNewTextPlaceholders": "Put a text on the puzzle",
  "i18n.button.ignore": "Ignore",
  "i18n.button.ignoreAndContinue": "Continue anyway",
  "i18n.button.mobile.createNewTextPlaceholders": "Text",
  "i18n.button.noChanges": "No Thanks, Close Window",
  "i18n.button.ok": "OK",
  "i18n.button.photos": "Photos",
  "i18n.button.retry": "Retry",
  "i18n.button.uploadPhotos": "Upload photo(s)",
  "i18n.button.withSmartSorted": "Upgrade to SMART SORTED",
  "i18n.button.withoutSmartSorted": "No Thanks, Close Window",
  "i18n.control.colorChooser.color": "Color",
  "i18n.control.fontChooser.placeholderText": "Font",
  "i18n.control.imageQuality.checkImages": "Check photo resolution",
  "i18n.control.imageQuality.imageSuitability": "Photo quality:",
  "i18n.control.imageQuality.indicatorAltText": "Photo quality",
  "i18n.control.imageZoom.zoom": "Zoom:",
  "i18n.control.templateChooser.title": "Choose layout",
  "i18n.control.textEditing.rejectMessage.characterWontFit": "For a better readability, please shorten length of text / line.",
  "i18n.control.textEditing.rejectMessage.fontFamilyTooLarge": "The chosen font is too large for this text.",
  "i18n.control.textEditing.rejectMessage.fontSizeTooLarge": "The maximum possible font size for this text is reached.",
  "i18n.control.textEditing.rejectMessage.fontSizeTooSmall": "The minimum possible font size for this text is reached.",
  "i18n.control.textEditing.rejectMessage.insertLineBreak": "Please insert a line break",
  "i18n.control.textEditing.rejectMessage.insertLineBreakOrResizeTextField": "Please continue writing in a second line or enlarge the text field",
  "i18n.control.textEditing.rejectMessage.invalidCharacters": "Please check your text, not all characters are supported by this font.",
  "i18n.control.textEditing.rejectMessage.maxCharactersReached": "The maximum number of characters is reached ",
  "i18n.control.textEditing.rejectMessage.maxLinesReached": "For a better readability, please shorten length of text / line.",
  "i18n.control.textEditing.rejectMessage.resizeTextField": "Please enlarge the text field",
  "i18n.dialog.deletePlaceholder.message": "This step cannot be made undone",
  "i18n.dialog.deletePlaceholder.title": "Do you want to delete the place holder",
  "i18n.dialog.error.title": [
    "An error has occurred",
    "Some errors have occurred"
  ],
  "i18n.dialog.insufficientImageQuality.message": "The resolution of the image is too low to achieve a sharp print result!",
  "i18n.dialog.smartSorted.message": "With SMART SORTED you can complete your photo puzzle with 1000 pieces in an innovative and effortless way, even without an image example.",
  "i18n.dialog.smartSorted.title": "Puzzle success experience guaranteed",
  "i18n.dialog.unchangedPlaceholders.boxTitle.message": "Please click on \"{{text}}\", to change the box title.",
  "i18n.dialog.unchangedPlaceholders.boxTitle.title": "The box title has not been changed",
  "i18n.dialog.unchangedPlaceholders.buttons.clear.label": "Continue without a box title",
  "i18n.dialog.unchangedPlaceholders.image.message": [
    "Please insert a photo by clicking on the placeholder",
    "Please insert photos by clicking on the placeholders"
  ],
  "i18n.dialog.unchangedPlaceholders.image.title": [
    "One placeholder is still empty",
    "Some placeholders are still empty"
  ],
  "i18n.dialog.unchangedPlaceholders.message": [
    "A placeholder has not been changed.",
    "Some placeholders have not been changed."
  ],
  "i18n.dialog.unchangedPlaceholders.misc.message": [
    "Please click on the photo and text placeholders to change your collage",
    "Please click on the photo and text placeholders to change your collage"
  ],
  "i18n.dialog.unchangedPlaceholders.misc.title": [
    "Some placeholders have not been changed",
    "Some placeholders have not been changed"
  ],
  "i18n.dialog.unchangedPlaceholders.text.message": [
    "Please click on the text placeholder to change your text",
    "Please click on the text placeholders to change your texts"
  ],
  "i18n.dialog.unchangedPlaceholders.text.title": [
    "A text placeholder has not been changed",
    "Some text placeholders have not been changed"
  ],
  "i18n.dialog.unchangedPlaceholders.title": "unchanged placeholders",
  "i18n.error.additionalInfoItemsError.message": "loading error information layer",
  "i18n.error.additionalInfoItemsError.title": "loading error ",
  "i18n.error.deprecatedBrowserError.message": "The browser you are using is no longer supported. Please update to a newer version.",
  "i18n.error.deprecatedBrowserError.title": " ",
  "i18n.error.designerExpiredError.message": "The designing process has been interrupted by a too-long pause, causing that it cannot be continued. May we kindly ask you to start the designing process again.",
  "i18n.error.designerExpiredError.title": "Designing interrupted",
  "i18n.error.fontLoadingError.message": "A font could not be loaded",
  "i18n.error.fontLoadingError.title": "loading error",
  "i18n.error.imageLoadingError.message": "A photo could not be loaded. It was removed from the design area and gallery.",
  "i18n.error.imageLoadingError.title": "Download error",
  "i18n.error.imageProvisionError.message": "One or more photos could not be processed. The media type is probably not supported.",
  "i18n.error.imageProvisionError.title": "A photo could not be processed",
  "i18n.error.imageSelectionError.message": "File \"{{reference1}}\" could not be processed.",
  "i18n.error.imageSelectionError.title": "Error during photo upload",
  "i18n.error.imageSizeLimitExceededError.message": "The photo you uploaded is too high in size.\nPlease reduce your photo below 180 megapixels and upload it again.",
  "i18n.error.imageSizeLimitExceededError.title": "Error during photo upload",
  "i18n.error.imageUploadError.message": "An internet connection problem occurred.\nPlease try again later.",
  "i18n.error.imageUploadError.title": "Error during photo upload",
  "i18n.error.inlineSVGLoadingError.message": "Tolerance frame \"{{reference1}}\" could not be loaded.",
  "i18n.error.inlineSVGLoadingError.title": "Download error",
  "i18n.error.invalidCharConfigError.message": "This font is not applicable, please choose another font.",
  "i18n.error.invalidCharConfigError.title": "Font not applicable",
  "i18n.error.malformedProductError.message": "One or more products could not be transferred to our server. The product may no longer be available or the designing of the product may have taken too long. We are afraid that you have to start all over again. We are sorry for any inconvenience caused.",
  "i18n.error.malformedProductError.title": "Transformation error",
  "i18n.error.notInStockError.message": "The product you have selected is currently not available.\nBy clicking on our logo at the top left, you will be taken to the home page, where another product can be chosen.",
  "i18n.error.notInStockError.title": " ",
  "i18n.error.offlineNotice": "Your internet connection seems to have been interrupted. You may continue designing your product as soon as your connection has been restored.",
  "i18n.error.templateLoadingError.message": "Template \"{{ error.reference[0] }}\" could not be loaded.\nPlease try again later.",
  "i18n.error.templateLoadingError.title": "Download error",
  "i18n.error.transformationError.message": "The transformation could not be processed",
  "i18n.error.transformationError.title": "Transformation error",
  "i18n.error.traudlLoadingError.message": "Please try again or use a different photograph.",
  "i18n.error.traudlLoadingError.title": "An AI filter could not be applied.",
  "i18n.error.unsupportedMediaTypeError.message": "\"{{reference1}}\" has an unsupported media type.",
  "i18n.error.unsupportedMediaTypeError.title": "Error during photo upload",
  "i18n.error.uploadProductError.message": "One or some products could not be transferred to the server.\nPlease try again later.",
  "i18n.error.uploadProductError.title": "Transfer error",
  "i18n.error.zoomModeError.message": "The text from your previous layout could not be adopted. Please enter a new text.",
  "i18n.error.zoomModeError.title": "Text not adopted",
  "i18n.gallery.uploadPhotos.info": "Please click the \"Upload photo(s)\" button",
  "i18n.gallery.uploadProgress": [
    "Uploading photo ...",
    "Photos uploaded: {{current}} of {{total}}"
  ],
  "i18n.price.price": "Price",
  "i18n.price.reduction": "You save",
  "i18n.price.total": "Total price",
  "i18n.priceDisplay.times": [
    "{{value}} Item at {{pricePerUnit}}",
    "{{value}} Items at {{pricePerUnit}}"
  ],
  "i18n.progress.stepAdditionalProducts": "Accessories (optional)",
  "i18n.progressOverlay.message.lines.one": "Thanks for your carefully designed creation.",
  "i18n.progressOverlay.message.lines.two": "We are preparing the following step for you...",
  "i18n.template.insertText": "You may enter a text here",
  "i18n.toolbox.gallery.title": "Select photos",
  "i18n.toolbox.image.title": "Edit photo",
  "i18n.toolbox.layout.template.suitableFor": [
    "1 photo",
    "{{value}} photos"
  ],
  "i18n.toolbox.layout.title": "Change Layout",
  "i18n.toolbox.layout.triggerText": "Layout",
  "i18n.toolbox.preview.title": "3D Preview",
  "i18n.toolbox.productChooser.title": "Change product",
  "i18n.toolbox.productChooser.triggerText": "Product",
  "i18n.toolbox.text.title": "Edit text"
};


export class LocaleEnIE {
  public getPlural(n: number): number
  {
    const pluralForm = (n != 1);
    if (typeof(pluralForm) === 'boolean') {
      return pluralForm ? 1 : 0;
    }
    return pluralForm;
  }
  public getTranslations(): any
  {
    return TRANSLATIONS;
  }
}
/* tslint:enable */
